




































































































































































































































































































import { Component, Vue, Prop, Watch, Emit } from 'nuxt-property-decorator'
import MapSelect from '~/components/consumer_map/mapSelect.vue'
import IconButton from '~/components/shared/buttons/IconButton.vue'
import BedroomButtonGroup from '~/components/consumer_map/BedroomButtonGroup.vue'
import MapSearchButton from '~/components/consumer_map/MapSearchButton.vue'
import FiltersBox from '~/components/sales_map_v3/FiltersBox.vue'
import { getConsumerMapFilter } from '~/api/consumer_map.api'
import { FilterFields } from '~/models/filters'
import { PublicProject } from '~/models/project'
import SeasonPicker from '~/components/sales_map_v3/SeasonPicker.vue'
import CustomFilters from '~/components/consumer_map_v3/CustomFilters.vue'
import AvailableDateFilter from '~/components/shared/AvailableDateFilter.vue'
import { AcreageOptions } from '~/constants/acreageOptions'

type FiltersSettings = {
  price?: any
  builder?: any
  bedrooms?: any
  architecture?: any
  neighborhood?: any
  lotAcreage?: any
  available?: any
  propertyType?: any
}

@Component({
  components: {
    MapSelect,
    IconButton,
    BedroomButtonGroup,
    MapSearchButton,
    FiltersBox,
    SeasonPicker,
    CustomFilters,
    AvailableDateFilter,
  },
})
export default class MapFilter extends Vue {
  @Prop({ default: null }) project: PublicProject
  @Prop({ default: 'map' }) activeView: string
  @Prop({ default: 0 }) propertiesCount: number
  @Prop({ default: 0 }) propertiesShown: number
  @Prop({
    default: {
      price: true,
      bedrooms: true,
      builder: true,
      architecture: true,
      propertyType: true,
    },
  })
  filtersVisibilitySettings: FiltersSettings

  prices: FilterFields[]
  builders: FilterFields[]
  styles: FilterFields[]
  beds: FilterFields[]
  mFilters: boolean = false
  openedMenu: string = ''
  searchActive: boolean = false
  priceOptions: any[] = []
  bedroomOptions: any[] = []
  builderOptions: any[] = []
  architectureOptions: any[] = []
  neighborhoodOptions: any[] = []
  lotAcreageOptions: any[] = []
  propertyTypeOptions: any[] = []
  selectedPriceOptions: any[] = []
  selectedBedRooms: any = null
  selectedBuilderOptions: any[] = []
  selectedArchOptions: any[] = []
  selectedNeighborhoodOptions: any[] = []
  selectedLotAcreageOptions: any[] = []
  selectedPropertyTypeOptions: any[] = []
  customFilters: any = null
  selectedCustomFilterOptions: any[] = []
  moveInDate: any = null

  created() {
    this.customFilters = this.customFiltersFetch(this.$route.params.slug)
  }

  customFiltersFetch(projectSlug: string) {
    try {
      const filters = require(`~/assets/customFilters/${projectSlug}.json`)
      return filters
    } catch (error) {
      return null
    }
  }

  @Emit('seasonChange')
  seasonChange(value: boolean): boolean {
    return value
  }

  get seasonEnabled() {
    return !!this.project?.config?.enable_season
  }

  async mounted(): Promise<void> {
    try {
      const filters = await Promise.all([
        getConsumerMapFilter('prices', this.$route.params.slug),
        getConsumerMapFilter('bedrooms', this.$route.params.slug),
        getConsumerMapFilter('builders', this.$route.params.slug),
        getConsumerMapFilter('architectures', this.$route.params.slug),
        getConsumerMapFilter('neighborhood', this.$route.params.slug),
        getConsumerMapFilter('lot_property_types', this.$route.params.slug),
      ])

      this.priceOptions = filters[0].map((filter) => ({
        ...filter,
        type: 'price',
      }))
      this.bedroomOptions = filters[1].map((filter) => ({
        ...filter,
        type: 'bedrooms',
      }))
      this.builderOptions = filters[2].map((filter) => ({
        ...filter,
        type: 'builder',
      }))
      this.architectureOptions = filters[3].map((filter) => ({
        ...filter,
        type: 'arch',
      }))

      this.neighborhoodOptions = filters[4].map((filter) => ({
        ...filter,
        type: 'neighborhood',
      }))

      this.propertyTypeOptions = filters[5].map((filter) => ({
        ...filter,
        type: 'property_type',
      }))
      const acreageOptions: Array<{ value: string; label: string }> =
        AcreageOptions

      this.lotAcreageOptions = acreageOptions.map((filter) => ({
        ...{ label: filter.label, value: filter.value },
        type: 'acreage',
      }))

      if (this.$route.query.price) {
        const queryPrice = this.$route.query.price

        if (Array.isArray(queryPrice)) {
          this.selectedPriceOptions = queryPrice.map((prices: any) =>
            this.priceOptions.find(({ value }) => prices === value)
          )
        } else {
          this.selectedPriceOptions = [
            this.priceOptions.find(({ value }) => queryPrice === value),
          ]
        }
      }
      if (this.$route.query.builder) {
        const queryBuilder = this.$route.query.builder
        if (Array.isArray(queryBuilder)) {
          this.selectedBuilderOptions = queryBuilder.map((builder: string) =>
            this.builderOptions.find(({ value }) => +builder === value)
          )
        } else {
          this.selectedBuilderOptions = [
            this.builderOptions.find(({ value }) => +queryBuilder === value),
          ]
        }
      }
      if (this.$route.query.beds) {
        const queryBeds = this.$route.query.beds
        this.selectedBedRooms = this.bedroomOptions.find(
          ({ value }) => +queryBeds === value
        )
        if (this.selectedBedRooms) {
          this.updateRoomsFilter(this.selectedBedRooms.value)
        }
      }
      if (this.$route.query.style) {
        const queryStyle = this.$route.query.style
        if (Array.isArray(queryStyle)) {
          this.selectedArchOptions = queryStyle.map((style: string) =>
            this.architectureOptions.find(({ value }) => +style === value)
          )
        } else {
          this.selectedArchOptions = [
            this.architectureOptions.find(({ value }) => +queryStyle === value),
          ]
        }
      }

      if (this.$route.query.neighborhood) {
        const queryNeighborhood = this.$route.query.neighborhood
        if (Array.isArray(queryNeighborhood)) {
          this.selectedNeighborhoodOptions = queryNeighborhood.map(
            (neighborhood: string) =>
              this.neighborhoodOptions.find(
                ({ value }) => neighborhood === value
              )
          )
        } else {
          this.selectedNeighborhoodOptions = [
            this.neighborhoodOptions.find(
              ({ value }) => queryNeighborhood === value
            ),
          ]
        }
      }

      if (this.$route.query.acreage) {
        const queryLotAcreage = this.$route.query.acreage
        if (Array.isArray(queryLotAcreage)) {
          this.selectedLotAcreageOptions = queryLotAcreage.map(
            (lotAcreage: string) =>
              this.lotAcreageOptions.find(({ value }) => lotAcreage === value)
          )
        } else {
          this.selectedLotAcreageOptions = [
            this.lotAcreageOptions.find(({ value }) => {
              return queryLotAcreage === value
            }),
          ]
        }
      }

      if (this.$route.query.move_in_date) {
        const queryMoveInDate = this.$route.query.move_in_date
        this.updateMoveInDateFilter(queryMoveInDate as string)
        delete this.$route.query.move_in_date
      }

      if (this.$route.query.property_type) {
        const queryPropertyType = this.$route.query.property_type
        if (Array.isArray(queryPropertyType)) {
          this.selectedPropertyTypeOptions = queryPropertyType.map(
            (propertyType: string) =>
              this.propertyTypeOptions.find(
                ({ value }) => propertyType === value
              )
          )
        } else {
          this.selectedPropertyTypeOptions = [
            this.propertyTypeOptions.find(
              ({ value }) => queryPropertyType === value
            ),
          ]
        }
      }

      // translating custom filters query params into visual selected elements and also BE payload params
      if (this.customFilters?.show) {
        const queries = this.$route.query
        Object.keys(queries).forEach((filterKeyName) => {
          const filtersDefinition = this.customFilters.controls || []

          filtersDefinition.forEach((filterObjectDefinition: any) => {
            if (!filterObjectDefinition.nested) {
              if (filterObjectDefinition.id === filterKeyName) {
                let valuesList = []
                if (!Array.isArray(queries[filterKeyName])) {
                  valuesList = [queries[filterKeyName]]
                } else {
                  valuesList = [...queries[filterKeyName]]
                }
                valuesList.forEach((filterValue: any) => {
                  const option = filterObjectDefinition.settings.options.find(
                    (option: any) => option.value === filterValue
                  )
                  this.selectedCustomFilterOptions.push(option)
                })
              }
            } else {
              filterObjectDefinition.controls.forEach((nestedFilter: any) => {
                if (nestedFilter.id === filterKeyName) {
                  let valuesList = []
                  if (!Array.isArray(queries[filterKeyName])) {
                    valuesList = [queries[filterKeyName]]
                  } else {
                    valuesList = [...queries[filterKeyName]]
                  }
                  valuesList.forEach((filterValue: any) => {
                    const option = nestedFilter.settings.options.find(
                      (option: any) => option.value === filterValue
                    )
                    this.selectedCustomFilterOptions.push(option)
                  })
                }
              })
            }
          })
        })
      }
    } catch (error) {
      this.$toast.error(`There was an error loading the filters, try again!`)
    }
  }

  @Watch('filtersSelected')
  onUpdateRoomsFilterChange(value: []) {
    this.$emit('handleFilterChange', value)
  }

  updateRoomsFilter(rooms: number): void {
    const selectedOptions = {
      value: rooms,
      label: `Beds ${rooms}`,
      type: 'bedrooms',
    }

    this.selectedBedRooms = selectedOptions
  }

  get filtersSelected(): any[] {
    const filtersSelected: any[] = [...this.selectedPriceOptions]

    if (this.selectedBedRooms) filtersSelected.push(this.selectedBedRooms)

    filtersSelected.push(
      ...this.selectedBuilderOptions,
      ...this.selectedArchOptions,
      ...this.selectedNeighborhoodOptions,
      ...this.selectedLotAcreageOptions
    )
    if (this.moveInDate) filtersSelected.push(this.moveInDate)
    if (this.selectedPropertyTypeOptions)
      filtersSelected.push(...this.selectedPropertyTypeOptions)
    if (this.selectedCustomFilterOptions)
      filtersSelected.push(...this.selectedCustomFilterOptions)

    return filtersSelected
  }

  handleMenuChange(menu: string) {
    this.openedMenu = menu
  }

  handleSearchButton() {
    this.searchActive = !this.searchActive
  }

  handlePriceCheck(selectedOptions: []) {
    this.selectedPriceOptions = selectedOptions
  }

  handleBuilderCheck(selectedOptions: []) {
    this.selectedBuilderOptions = selectedOptions
  }

  handleArchCheck(selectedOptions: []) {
    this.selectedArchOptions = selectedOptions
  }

  handleNeighborhoodCheck(selectedOptions: []) {
    this.selectedNeighborhoodOptions = selectedOptions
  }

  handleLotAcreageCheck(selectedOptions: []) {
    this.selectedLotAcreageOptions = selectedOptions
  }

  handleCheck(selectedOptions: []) {
    this.selectedCustomFilterOptions = selectedOptions
  }

  handlePropertyTypeCheck(selectedOptions: []) {
    this.selectedPropertyTypeOptions = selectedOptions
  }

  updateMoveInDateFilter(value: string): void {
    const moveInDate = {
      value,
      label: `Move in Date ${value}`,
      type: 'move_in_date',
    }
    this.moveInDate = value ? moveInDate : null
  }

  clearFilter(filter: FilterFields) {
    if (filter.type === 'price')
      this.selectedPriceOptions = this.selectedPriceOptions.filter(
        (opt) => opt.value !== filter.value
      )
    else if (filter.type === 'builder')
      this.selectedBuilderOptions = this.selectedBuilderOptions.filter(
        (opt) => opt.value !== filter.value
      )
    else if (filter.type === 'arch')
      this.selectedArchOptions = this.selectedArchOptions.filter(
        (opt) => opt.value !== filter.value
      )
    else if (filter.type === 'neighborhood')
      this.selectedNeighborhoodOptions =
        this.selectedNeighborhoodOptions.filter(
          (opt) => opt.value !== filter.value
        )
    else if (filter.type === 'acreage')
      this.selectedLotAcreageOptions = this.selectedLotAcreageOptions.filter(
        (opt) => opt.value !== filter.value
      )
    else if (filter.type === 'bedrooms') this.selectedBedRooms = null
    else if (filter.type === 'propertyType')
      this.selectedPropertyTypeOptions =
        this.selectedPropertyTypeOptions.filter(
          (opt) => opt.value !== filter.value
        )
    else if (filter.classification === 'custom') {
      this.selectedCustomFilterOptions =
        this.selectedCustomFilterOptions.filter(
          (opt) => opt.value !== filter.value
        )
    } else if (filter.type === 'move_in_date') this.moveInDate = null
  }

  clearFilters() {
    this.selectedPriceOptions = []
    this.selectedBuilderOptions = []
    this.selectedArchOptions = []
    this.selectedNeighborhoodOptions = []
    this.selectedLotAcreageOptions = []
    this.selectedBedRooms = null
    this.selectedCustomFilterOptions = []
    this.moveInDate = null
    this.selectedPropertyTypeOptions = []
    this.mFilters = false
  }
}
